.registrationContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
}

.datePickerRow {
	display: flex;
	flex-direction: row;
	gap: 0.625rem;
	align-items: center;
}

.sessionEditorHeaderContainer {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.625rem;
	width: 100%;

	& .sessionEditorTextCol {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;

		& .title {
			font-weight: 600;
			font-size: 0.9375rem;
			line-height: 1.5;
			letter-spacing: -0.43px;
			color: #212121;
		}

		& .description {
			color: #6b6b6b;
			font-weight: 400;
			font-size: 0.875rem;
			line-height: 1.4;
			letter-spacing: -0.08px;
		}
	}
}

.verticalTextFieldLabelErrorRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-left: 0.25rem;
	gap: 0.5rem;
}

.liveFormControl:global(.MuiFormControlLabel-root) {
	align-items: flex-start;
	margin: 0;
	gap: 0.25rem;
	width: 100%;

	& .dateLabel {
		color: #212121;
		font-weight: 500;
		font-size: 0.875rem;
		line-height: 1.6;
	}
}

@media (max-width: 768px) {
	.datePickerRow {
		flex-direction: column;
	}

	.sessionEditorHeaderContainer {
		flex-direction: column;

		& .sessionEditorTextCol {
			align-items: center;

			& .description {
				text-align: center;
			}
		}
	}
}
